var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"city-map-legend__block"},[_c('div',{staticClass:"city-map-legend__subtitle",domProps:{"innerHTML":_vm._s(_vm.city)}})])}
var staticRenderFns = []

export { render, staticRenderFns }